import { Dispatch, SetStateAction, useCallback } from 'react'
import { getInitialScheduleValue } from 'reducks/schedule/selectors'
import { StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { FirebaseDocRefType } from 'firebase/index'

const useToggleTypeDaily = (
  breadRef: FirebaseDocRefType,
  storeRef: FirebaseDocRefType,
  setIsTypeDaily: Dispatch<SetStateAction<boolean>>,
  openDeleteScheduleCautionModal: (type: StockUnionType) => void,
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setScheduledGeneration: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(() => {
    setIsTypeDaily((prevState) => {
      if (prevState) {
        openDeleteScheduleCautionModal('daily')
        return true
      } else {
        setDailySchedules([getInitialScheduleValue(breadRef, storeRef.collection('store_schedules').doc(), 'daily')])
        setTimeout(() => setScheduledGeneration(true), 0)
        return !prevState
      }
    })
  }, [breadRef, storeRef, setIsTypeDaily, openDeleteScheduleCautionModal, setDailySchedules, setScheduledGeneration])
}

export default useToggleTypeDaily
